<main>
  <app-toaster></app-toaster>
  @if (_auth.isUserAuthenticated()) {
    <app-navbar (collapseMenu)="handleMenuOpen($event)"></app-navbar>
  }
  <section class="page-content">
    @if (_auth.isUserAuthenticated()) {
      <ng-container *appHasNotPermission="'fornecedor>cadastro>finalizar-cadastro'">
        <app-sidebar [collapsed]="isMenuCollapsed()" ></app-sidebar>
      </ng-container>
      }

    

    <section
      class="main-content__wrapper flex-fill"
      [ngClass]="{
        'overflow-y-scroll': _auth.isUserAuthenticated(),
      }"
    >
      @if (_auth.isUserAuthenticated()) {
        <user-section-wrapper>
          <router-outlet></router-outlet>
        </user-section-wrapper>
      } @else {
        <sign-section-wrapper>
          <router-outlet></router-outlet>
        </sign-section-wrapper>
      }
    </section>
  </section>
</main>
